(() => {
  if(window.NLTCartCapture)return;
  window.NLTCartCapture={version:1};
  const root=()=>window.Shopify?.routes?.root||'/', attribute='Referencia de carrito NLT';
  let timer,busy=false,queued=false,lastSnapshot='',previousCart='',lastAttempt=0;
  function schedule(delay=700){clearTimeout(timer);timer=setTimeout(capture,delay);}
  function permitted(){
    const privacy=window.Shopify?.customerPrivacy;
    return privacy && typeof privacy.preferencesProcessingAllowed==='function' && privacy.preferencesProcessingAllowed();
  }
  async function capture(){
    if(document.visibilityState==='hidden'||!permitted())return;
    if(busy){queued=true;return;}
    if(Date.now()-lastAttempt<4000){schedule(4100-(Date.now()-lastAttempt));return;}
    busy=true;lastAttempt=Date.now();
    try{
      const response=await fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
      if(!response.ok)throw Error('cart');const cart=await response.json();
      const cartId=String(cart.token||'').split('?')[0];
      if(!/^[A-Za-z0-9_=-]{16,512}$/.test(cartId))return;
      if(!cart.item_count&&previousCart!==cartId&&!/^NLT-(?:[A-F0-9]{4}-){2}[A-F0-9]{4}$/.test(cart.attributes?.[attribute]||''))return;
      const payload={cart_id:cartId,currency:cart.currency,total_price:cart.total_price,items:cart.items.map(item=>({product_id:String(item.product_id),variant_id:String(item.variant_id),title:item.title,sku:item.sku||'',quantity:item.quantity,final_price:item.final_price,final_line_price:item.final_line_price,url:item.url||''}))};
      const fingerprint=JSON.stringify(payload);if(fingerprint===lastSnapshot)return;
      payload.captured_at=Date.now();
      const saved=await fetch(root()+'apps/nlt-taller/carts/capture',{method:'POST',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json','X-NLT-Cart':'1'},body:JSON.stringify(payload),signal:AbortSignal.timeout(12000)});
      if(!saved.ok)throw Error('save');const receipt=await saved.json();if(!receipt.ok)throw Error('save');
      if(cart.item_count&&cart.attributes?.[attribute]!==receipt.reference){
        const updated=await fetch(root()+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[attribute]:receipt.reference}}),signal:AbortSignal.timeout(12000)});
        if(!updated.ok)throw Error('reference');
        document.querySelectorAll('nlt-cart-reference').forEach(element=>element.refresh?.());
      }
      lastSnapshot=fingerprint;previousCart=cartId;
      document.dispatchEvent(new CustomEvent('nlt:cart-saved',{detail:{reference:receipt.reference,saved:receipt.saved,saved_at:receipt.saved_at}}));
    }catch{
      // A recording failure must not interrupt shopping or checkout.
      schedule(15000);
    }finally{busy=false;if(queued){queued=false;schedule();}}
  }
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    [PUB_SUB_EVENTS.cartUpdate,PUB_SUB_EVENTS.cartOpen].filter(Boolean).forEach(topic=>subscribe(topic,()=>schedule()));
  }
  window.addEventListener('pageshow',()=>schedule());window.addEventListener('focus',()=>schedule());
  document.addEventListener('visitorConsentCollected',()=>schedule());
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')schedule();});
  setInterval(()=>{if(document.visibilityState==='visible')schedule();},30000);
  if(window.Shopify?.customerPrivacy)schedule();
  else if(typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)schedule();});
})();
